import propsToData from '@/mixins/props-to-data';
import { mapState as rootMapState } from 'pinia';
import { usePageStore, useUserStore, getStore } from '@/store';
import {
    mapState,
    mapActions
} from '@/store/helpers';
import getUseStore from './_store';
import { getIndexMixin, getPlaceHolderMixin } from './_center-adaptor';
import { SAVE_SEARCH_STATUS } from './_util';
// import global from '@/common/global';
import util from '@/common/util';
import {
    SEARCH_DATA_ACTION,
    LAYOUT_UPDATE_MUTATION
} from '@/components/search-result/_store/types';
import {
    SET_SEARCH_DATA_READY
    // SET_BLOCK_ID
} from '../md-search/_store/config';
import searchCommon from '../md-search/_mixins/common';
import { numberFormat } from '../../common/format';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData, init, getDftSuggestion } from './asyncData';
import { SET_LISTING_SOURCE } from './_store/types';
import { buildUrl } from '@/router/index.js';
import { getRootVar } from '@/init/data/getDataFromJsp.js';
import { colorToAlpha } from '@/common/utils/handle-color.js';
// TODO
// update:bottom
// listing-search 'bottom'
export default (isSearchCenter) => {
    return {
        i18next: {
            ns: 'md-search-bar'
        },
        mixins: [propsToData, searchCommon, getIndexMixin(isSearchCenter), getPlaceHolderMixin(isSearchCenter)],
        componentName: 'md-search-bar',
        _getUseStore: getUseStore,
        asyncData: mapAsyncData(asyncData),
        computed: {
            ...rootMapState(usePageStore, ['isSearchCenter', 'page', 'forCMS', 'siteId', 'hasLoggedIn']),
            ...rootMapState(useUserStore, ['hasLoggedIn']),
            ...mapState({
                fetcherData: store => store.fetcherData,
                layout: store => store.layout,
                listingSourceReady: store => store.listingSourceReady,
                listingSource: store => store.listingSource,
                mapCondition: store => store.mapCondition,
                result: store => store.result,
                fetchedSearchData: store => store.fetchedSearchData
            }),
            ...mapState([
                'isBigMap',
                'isGridOrList',
                'listingType',
                'allConditions',
                'filterCount',
                'searchParamsWithMap',
                'moreLen',
                'otherSearchParams'
            ]),
            isMobile() {
                return this.platform.isMobile;
            },
            isListingPage({ page }) {
                return ['listing', 'sold-listing'].indexOf(page.pageKey) !== -1;
            },
            widget({ page }) {
                return page.widget;
            },
            hideSearchBtn() {
                return this.hideSearch;
            },
            count() {
                return this.result.counts;
            },
            formatCount() {
                if (this.result) {
                    return numberFormat(this.result.counts, true, 1);
                } else {
                    return 0;
                }
            },
            layoutToShow() {
                if (this.layout === 'map') {
                    return 'grid';
                }
                return 'map';
            },
            snapshotAbled() {
                return (this.keywords && this.keywords.length > 0) ||
                    this.mapCondition.mapPath ||
                    this.mapCondition.mapSearch
                    ? true
                    : false;
            },
            isReallyUser() {
                return this.platform.isReallyUser
            },
            cmpSnapshotHoverTip() {
                return (
                    this.snapshotHoverTip ||
                    this.$t('md-search-bar.pleaseSearchAValid')
                );
            },
            showSwitchLayout({ isBigMap, hideSearchBtn, locationOnly, isGridOrList }) {
                return !isBigMap && !hideSearchBtn && !locationOnly && !isGridOrList
            },
            // 计算文本颜色变量
            textColorVars() {
                const color = this.textColor;
                if (!color) {
                    return {};
                }
                return {
                    '--g-text-color_10': colorToAlpha(color, 0.1),
                    '--g-text-color_20': colorToAlpha(color, 0.2)
                };
            }
        },
        data: function() {
            const blockData = {
                // block data
                presetFilters: [],
                presetFiltersV2: {},
                // listingSource: '',
                keywordsPlaceholder: ''
            };
            return {
                moreDisplayNone: false,
                isKeywordSearchVisible: false,
                hasConditionOnUrl: false,
                showSaveAlert: false,
                hasShowSaveAlert: false,
                showSaveAlertTime: 0,
                show: false,
                // fetchedSearchData: false,
                ...blockData,
                keywordSearchRef: null,
                hideTemp: false,
                snapshotHoverTip: '',
                searchTagCount: 0,
                hasShowSearchBar: this.pageLocation.query.listingSource?.toLowerCase?.() != 'single property promotion',
                textColor: '' // 存储文本颜色
            };
        },
        props: {
            searchBarOnly: {
                type: Boolean,
                default: true
            },
            hideSearch: {
                type: Boolean,
                default: false
            },
            locationOnly: {
                type: Boolean,
                default: false
            },
            mlsId: {
                type: String,
                default: ''
            },
            listingSourceOut: {
                type: String,
                default: ''
            },
            saveSearchStatus: {
                type: String,
                validator(value) {
                    return Object.values(SAVE_SEARCH_STATUS).includes(value);
                },
                default: SAVE_SEARCH_STATUS.listing
            }
        },
        inject: {
            pid: {
                from: 'id',
                default: ''
            }
        },
        provide() {
            return {
                searchBarOnly: this.searchBarOnly,
                hideSearchBtn: this.hideSearchBtn,
                locationOnly: this.locationOnly,
                mlsId: this.mlsId,
                conditionChange: this.conditionChange,
                textColorVars: () => this.textColorVars
            };
        },
        watch: {
            siteId: {
                // immediate: true,
                // 主要设置了 conditionSort 的值
                handler: function() {
                    this.init();
                    // this.$nextTick(async () => {
                    //     // this.updateBtm();
                    // });
                }
            },
            filterCount: {
                immediate: true,
                handler: function() {
                    /**
                     * 展示的前提：
                     * 用户未登录，且 Filter 数量大于等于 3
                     已登录用户不提示或 Filter 数量小于 3
                    固定显示 3s 后，用户做任意操作如滑屏、点击，气泡消失，不再出现
                    3s 后用户不做任意操作，不消失
                    刷新页面或重新访问，依然会提示
                    */
                    if (
                        (this.filterCount >= 3 &&
                            !this.hasLoggedIn &&
                            !this.hasShowSaveAlert) ||
                        (this.hasLoggedIn &&
                            this.filterCount > 0 &&
                            this.filterCount < 3 &&
                            !this.hasShowSaveAlert)
                    ) {
                        this.showSaveAlert = true;
                        this.hasShowSaveAlert = true;
                        this.showSaveAlertTime = Date.now();
                    }
                }
            },
            allConditions: {
                immediate: true,
                handler: function() {
                    if (this.forCMS && window.parent) {
                        window.parent.postMessage(
                            {
                                action: 'updateTags',
                                data: JSON.parse(JSON.stringify(this.allConditions))
                            },
                            '*'
                        );
                    }
                }
            }
        },
        methods: {
            ...mapActions({
                layoutUpdateMutation: LAYOUT_UPDATE_MUTATION,
                setSearchDataReady: SET_SEARCH_DATA_READY,
                setListingSource: SET_LISTING_SOURCE,
                searchDataAction: SEARCH_DATA_ACTION
            }),
            init: mapAsyncData(init),
            getDftSuggestion: mapAsyncData(getDftSuggestion),
            switchLayout() {
                let layout = this.layout === 'map' ? 'normal' : 'map';
                this.layoutUpdateMutation({
                    layout: layout
                });
            },
            showKeywordSearchInMore() {
                if (!this.isReallyUser) {
                    return; 
                }
                this.showKeywordSearch()
                this.moreDisplayNone = true;
            },
            showKeywordSearch() {
                if (!this.isReallyUser) {
                    return; 
                }
                this.isKeywordSearchVisible = true;
                if (!this.isMobile) {
                    this.keywordSearchRef?.focusInput();
                }
            },
            onKeywordSearchRef(e) {
                this.keywordSearchRef = e;
            },
            hideKeywordSearch() {
                this.moreDisplayNone = false;
                this.isKeywordSearchVisible = false;
            },
            saveSearch() {
                if (this.filterCount > 0) {
                    this.$refs.searchMore.saveSearch(true);
                }
            },
            showSearch() {
                util.enableScroll(false);
                this.show = true;
                // 处理后退关掉filter弹框
                var popstateFunc = event => {
                    event.preventDefault();
                    window.removeEventListener('popstate', popstateFunc);
                    util.enableScroll(true);
                    this.show = false;
                };
                window.addEventListener('popstate', popstateFunc);
                window.history.pushState({}, null, '#filter');
            },
            //ios 中fixed层级失效，因此在现实select弹框时需要暂时隐藏search more弹框，在关掉select下拉框时，需要显示searchmore弹框
            hideSearchTemp() {
                this.hideTemp = true;
            },
            cancelHideTemp() {
                this.hideTemp = false;
            },
            hideSearchFn() {
                util.enableScroll(true);
                this.show = false;
            },
            submitSearch() {
                if (this.submitDisabled) {
                    return; 
                }

                this.submitDisabled = true;
                setTimeout(() => {
                    this.submitDisabled = false;
                }, 500);
                this.$EventBus.$emit(
                    'change-url',
                    buildUrl({ name: 'listing', query: Object.assign(
                        {},
                        this.otherSearchParams,
                        this.searchParamsWithMap,
                        this.mapCondition
                    ) })
                    ,
                    'All Listing'
                );
            },
            clickSaveSnapshot() {
                this.$refs.searchMore &&
                    this.$refs.searchMore.clickSaveSnapshot();
            },
            clickMoreSearch() {
                this.hideSearchFn();
                if (this.searchBarOnly && !this.hideSearchBar) {
                    // hide search bar snapshot用
                    this.$nextTick(() => this.submitSearch());
                }
            },
            calcPosition() {
                if (!util.isSSRServer) {
                    this.$emit(
                        'update:bottom',
                        this.$parent.$el.offsetTop + this.$el.offsetHeight
                    );
                }
            },
            conditionChange(conditions) {
                this.$emit('conditionChange', conditions);
                this.listenHouseCount(conditions);
            },
            listenHouseCount(params = {}) {
                // md-search-bar 中用来更新在移动端more中的房源数量
                if (this.mdData?.isBlockRoot) {
                    let { condition, kee } = params;
                    if (['mapPath', 'mapSearch', 'mapRadius'].includes(kee)) {
                        return; 
                    }
                    delete condition.listingSource;
                    this.searchDataAction({ 
                        listOnly: true,
                        isMobile: this.isMobile
                    });
                }
            },
            changeTag(value) {
                this.searchTagCount = value;
            }
        },
        beforeMount() {
            let s = getStore(this._storeName, this.$pinia) || {}
            util.isSSRClient && this.blockOb?.dispatch(SET_SEARCH_DATA_READY, {
                name: this.blockName, 
                searchParams: s.searchParamsWithMap
            });
            this.getDftSuggestion();
        },
        mounted() {
            this.asyncDataPromise &&
                this.asyncDataPromise.then(() => {
                    this.$nextTick(() => {
                        this.$emit(
                            'update:bottom',
                            this.$parent.$el.offsetTop + this.$el.offsetHeight
                        );
                    });
                });
            document
                .querySelector('body')
                .addEventListener('touchstart', () => {
                    if (
                        this.showSaveAlert &&
                        this.showSaveAlertTime &&
                        Date.now() - this.showSaveAlertTime > 3000
                    ) {
                        this.showSaveAlert = false;
                    }
                });
            // 处理异步组件加载完成执行
            this.$emit('loaded', true);
            
            // 获取文本颜色
            try {
                const color = getRootVar('--g-text-color');
                if (color) {
                    this.textColor = color;
                }
            } catch (e) {
                console.warn('Failed to get text color:', e);
            }
        }
    };
}
